import { Button as AntButton } from 'antd'
import styled from 'styled-components'

import { E_Colors } from '@/helpers/colors'
import type { T_ButtonProps } from './button'


export const SC_Button = styled(
  ({ ...props }: T_ButtonProps) => <AntButton {...props} />
)`
  border-radius: 10px;
  ${(p) => p.$extraSize === 'veryLarge' ? 'height: 60px !important' : ''};
  ${(p) => p.$isVeryRadiused ? 'border-radius: 26px !important' : ''};

  &&& {
    ${(p) => p.$isBlack ? `background-color: ${E_Colors.TextPrimary} !important` : ''};
    ${(p) => p.$isBlack ? `color: ${E_Colors.White} !important` : ''};
  }

  &.ant-btn-primary,
  &.ant-btn-primary:hover {
    background-color: ${E_Colors.TextPrimary} !important;
    color: ${E_Colors.White} !important;
    border: 1px solid transparent;
    height: 54px;
    font-weight: 500;
    font-size: 16px;
    border-radius: 16px;
  }

  &.ant-btn-default {
    background-color: ${E_Colors.White};
    border-radius: 16px;
    border: 1px solid ${E_Colors.SystemGrey3};
    height: 54px;
    font-weight: 500;
    color: ${E_Colors.TextPrimary} !important;
    font-size: 16px;

    &:hover {
      background-color: transparent;
    }
  }

  &.ant-btn-dangerous.ant-btn-primary {
    background-color: ${E_Colors.GrayB2} !important;
    color: ${E_Colors.White} !important;
    border: none !important;

    &:hover {
      background-color: ${E_Colors.GrayB2} !important;
      color: ${E_Colors.White} !important;
      border: none !important;
    }
  }

  &.ant-btn-sm {
    border-radius: 8px;
    background-color: ${E_Colors.GrayF2F2F7} !important;
    min-width: 44px;
    border: none !important;
    height: 44px;
    display: flex;
    justify-content: center;

    &:hover {
      background-color: ${E_Colors.GrayF2F2F7} !important;
      border: none !important;
      box-shadow: none !important;
      transform: none !important
    }
  }

  &.ant-btn-text {
    font-size: 17px;
    color: ${E_Colors.SystemGrey};
    gap: 5px;
    font-weight: 500;
    padding: 0;
    background-color: transparent !important;
  }

  &&.ant-btn-background-ghost {
    background-color: ${E_Colors.White} !important;

    .ant-wave {
      display: none;
    }
  }

  ${({ customType }) => (
    customType === 'payment' &&
    `
      background-color: ${E_Colors.GrayF2F2F7} !important;
      border: none !important;
      height: 44px !important;
      display: flex;
      padding: 0 16px !important;
      border-radius: 10px !important;
      justify-content: space-between;
      font-size: 14px !important;
      font-weight: 400 !important;

      &:hover {
        background-color: ${E_Colors.GrayF2F2F7} !important;
        border: none !important;
        box-shadow: none !important;
        transform: none !important
      }
    `
  )}

  &&[disabled], &&[disabled]:hover {
    border: 0 !important;
    color: ${E_Colors.Gray88} !important;
    background-color: ${E_Colors.GrayE3} !important;
  }

  &&&.ant-btn-loading {
    color: ${E_Colors.Black} !important;
    background-color: ${E_Colors.GrayE3} !important;
  }
`
